<div data-test-id="textWithLogoCard" class="card">
  <div data-test-id="icon" class="card__common" [ngClass]="{
      'card__x-small': size === 'x-small',
      'card__small': size === 'small',
      'card__medium': size === 'medium',
      'card__large': size === 'large',
    }">
    <img data-test-id="image" [src]="logo" [alt]="text + 'Card Logo'">
    <div class="card__common--content">
      <div data-test-id="text" [innerHTML]="text"></div>
      <mat-chip-set>
        <mat-chip disableRipple *ngFor="let chip of chips">{{chip}}</mat-chip>
      </mat-chip-set>  
    </div>
    
  </div>
</div>
